//src/components/Admin/ReportManager/ReportLogModal.jsx

import { useState, forwardRef, useImperativeHandle } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import api from '../../../api/axios';

const ReportLogModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [logs, setLogs] = useState([]);

  const actionLabel = {
    pending: '대기 처리',
    blinded: '블라인드 처리',
    deleted: '삭제 처리',
    ignored: '무시 처리',
    restored: '복구 처리',
  };

  useImperativeHandle(ref, () => ({
    openModal(reportId) {
      api.get(`/api/reports/${reportId}/logs/`)
        .then(res => {
          const logData = res.data.logs || [];
          // 최신순으로 정렬
          const sortedLogs = [...logData].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          setLogs(sortedLogs);
          setOpen(true);
        })
        .catch(() => {
          alert('로그 조회 실패');
        });
    }
  }));

  const handleClose = () => {
    setOpen(false);
    setLogs([]);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>신고 처리 로그</DialogTitle>
      <DialogContent dividers>
        {logs.length === 0 ? (
          <Typography>로그가 없습니다.</Typography>
        ) : (
          <List>
            {logs.map((log, index) => (
              <ListItem key={index} divider>
                <ListItemText
                  primary={
                    <Typography fontWeight="bold">
                      {log.actor || '알 수 없음'}가 {actionLabel[log.action] || log.action} 했습니다
                    </Typography>
                  }
                  secondary={new Date(log.created_at).toLocaleString()}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
});

export default ReportLogModal;